
import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import {
  Button,
  TextField,
  CircularProgress,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import PumpFormFields from './PumpFormFields';
import ConfirmDialog from '../../../components/ConfirmDialog';
import SuccessSnackbar from '../../../components/SuccessSnackbar';
import FormContainerWrapper from '../../../components/FormContainerWrapper';
import { useAuth } from '../../../AuthContext';

// Validation schema using Yup
const pumpSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Pump name must be at least 2 characters')
    .max(50, 'Pump name must be less than 50 characters')
    .required('Pump name is required'),
  imei: Yup.string()
    .matches(/^\d{15}$/, 'IMEI must be exactly 15 digits')
    .required('IMEI is required'),
  model_number: Yup.string()
    .min(3, 'Model number must be at least 3 characters')
    .required('Model number is required'),
  serial_number: Yup.string()
    .min(5, 'Serial number must be at least 5 characters')
    .required('Serial number is required'),
    manufacturer: Yup.string()
    .min(5, 'make must be at least 5 characters')
    .required('make is required'),
  rating: Yup.number()
    .min(0.1, 'Rating must be greater than 0')
    .required('Rating is required'),
     controller_number: Yup.string()
        .min(5, 'Controller number must be at least 5 characters')
        .required('Controller number is required'), 
  sim_iccid: Yup.string()
    .matches(/^\d{19,20}$/, 'SIM ICCID must be 19 or 20 digits')
    .required('SIM ICCID is required'),
});

// Styled components
const SubmitButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(4),
  padding: theme.spacing(1.5),
  borderRadius: '10px',
  backgroundColor: '#1976d2',
  fontWeight: 'bold',
  fontSize: '1rem',
  '&:hover': {
    backgroundColor: '#1565c0',
  },
}));

const ActionButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(4),
  padding: theme.spacing(1.5),
  borderRadius: '10px',
  fontWeight: 'bold',
  fontSize: '1rem',
}));

const PumpUpdateDelete = () => {
  const [pumpData, setPumpData] = useState(null);
  const [searchImei, setSearchImei] = useState('');
  const [loading, setLoading] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openSuccessSnackbar, setOpenSuccessSnackbar] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [formValues, setFormValues] = useState(null);
const {allPumps,updatePump,fetchPumps,findPumpToUpdate}=useAuth();
  // Mock function to simulate fetching pump data by IMEI
  // const fetchPumpData = async (imei) => {
  //   setLoading(true);
  //   return new Promise((resolve) => {
  //     setTimeout(() => {
  //       const mockData = {
  //         name: 'Solar Pump 001',
  //         imei: imei,
  //         model_number: 'SPM-2023',
  //         serial_number: 'SN123456789',
  //         rating: 5.5,
  //         sim_iccid: '89340123456789012345',
  //       };
  //       setLoading(false);
  //       resolve(mockData);
  //     }, 1000);
  //   });
  // };



  
  const handleSearch = async () => {
    if (searchImei.length === 15 && /^\d{15}$/.test(searchImei)) {
    
      setLoading(true);
     // console.log('dekho search krne ke kiye allPumps',allPumps,'searchimei',searchImei)
     // `Pump with IMEI ${searchImei} not found`
      const pumpFound=await findPumpToUpdate(searchImei)
      if(pumpFound){
        if (!pumpFound.pump_info) {
          setSuccessMessage('Pump data is incomplete. Please contact support.');
          setOpenSuccessSnackbar(true);
          setLoading(false);
          return;
        }
        const {name,serial_number,model_number,sim_iccid,rating,imei,manufacturer,controller_number}=pumpFound.pump_info
        setPumpData({name,serial_number,model_number,sim_iccid,rating,imei,manufacturer,controller_number});
        setLoading(false);
      }
       else {
        setSuccessMessage('IMEI not found. Please enter a valid 15 digit IMEI');
        setOpenSuccessSnackbar(true);
        setLoading(false);
        setPumpData(null)
        
      }
    } else {
      setPumpData(null);
      setSuccessMessage('IMEI must be exactly 15 digits');
      setOpenSuccessSnackbar(true);
      
    }
  };

  const handleUpdateSubmit = (values) => {
    setFormValues(values);
    setOpenConfirmDialog(true);
  };

  const handleConfirmUpdate = async() => {

    try {
     
      await updatePump(formValues.imei, formValues);
      setOpenConfirmDialog(false);
      setSuccessMessage(`Pump ${formValues.name} Updated Successfully!`);
      setOpenSuccessSnackbar(true);
      setPumpData(null)
      setSearchImei('')
     // await fetchPumps();
    } catch (error) {
      setSuccessMessage('Failed to update pump. Please try again.');
      setOpenSuccessSnackbar(true);
     
    }
  };

  // const handleDelete = () => {
  //   setOpenDeleteDialog(true);
  // };

  // const handleConfirmDelete = async() => {
  //   try {
  //     if (!pumpData) return;
  //    await deletePump(pumpData.imei);
  //     setOpenDeleteDialog(false);
  //     setSuccessMessage(`Pump ${pumpData.name} Deleted Successfully!`);
  //     setOpenSuccessSnackbar(true);
  //     setPumpData(null);
  //     setSearchImei('');
  //   } catch (error) {
  //     setSuccessMessage('Failed to delete pump. Please try again.');
  //     setOpenSuccessSnackbar(true);
  //   }
  // };

  const handleCloseSuccess = () => {
    setOpenSuccessSnackbar(false);
  };

  return (
    <FormContainerWrapper title="Update Existing Pump">
      <div className="mb-6">
        <TextField
          label="Search by IMEI (15 digits)"
          variant="outlined"
          fullWidth
          value={searchImei}
          onChange={(e) => setSearchImei(e.target.value)}
          margin="normal"
          InputLabelProps={{
            shrink: true,
            sx: {
              fontSize: '1.2rem',
              '&.Mui-focused': {
                fontSize: '1.2rem',
                color: '#1976d2',
              },
            },
          }}
          InputProps={{
            notched: true,
            sx: {
              '& .MuiOutlinedInput-notchedOutline legend': {
                fontSize: '0.9rem',
                width: 'max-content',
              },
            },
          }}
          error={searchImei && !/^\d{15}$/.test(searchImei)}
          helperText={searchImei && !/^\d{15}$/.test(searchImei) ? 'IMEI must be exactly 15 digits' : ''}
        />
        <SubmitButton
          variant="contained"
          fullWidth
          onClick={handleSearch}
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} /> : 'Search'}
        </SubmitButton>
      </div>
      {pumpData && (
        <Formik
          initialValues={pumpData}
          validationSchema={pumpSchema}
          onSubmit={handleUpdateSubmit}
          enableReinitialize
        >
          {({ errors, touched }) => (
            <Form>
              <PumpFormFields errors={errors} touched={touched} disabledFields={['imei']} />
              <div className="flex justify-end space-x-4">
                <ActionButton
                  variant="contained"
                  color="primary"
                  type="submit"
                >
                  Update
                </ActionButton>
                {/* <ActionButton
                  variant="outlined"
                  color="error"
                  onClick={handleDelete}
                >
                  Delete
                </ActionButton> */}
              </div>
            </Form>
          )}
        </Formik>
      )}

      <ConfirmDialog
        open={openConfirmDialog}
        onClose={() => setOpenConfirmDialog(false)}
        onConfirm={handleConfirmUpdate}
        title="Confirm Updated Pump Details"
        content={
          formValues && (
            <div className="space-y-2">
              <p><strong>Pump Name:</strong> {formValues.name}</p>
              <p><strong>IMEI:</strong> {formValues.imei}</p>
              <p><strong>Model Number:</strong> {formValues.model_number}</p>
              <p><strong>Serial Number:</strong> {formValues.serial_number}</p>
              <p><strong>Make</strong> {formValues.manufacturer}</p>
              <p><strong>Rating:</strong> {formValues.rating} kW</p>
                {/* <p><strong>Panel No:</strong> {formValues.panel_number_list?.join(', ') || 'None'}</p> */}
               <p><strong>Controller No:</strong> {formValues.controller_number}</p>
              <p><strong>SIM ICCID:</strong> {formValues.sim_iccid}</p>
            </div>
          )
        }
      />

      {/* <ConfirmDialog
        open={openDeleteDialog}
        onClose={() => setOpenDeleteDialog(false)}
        onConfirm={handleConfirmDelete}
        title="Confirm Pump Deletion"
        content={
          <p>
            Are you sure you want to delete the pump <strong>{pumpData?.name}</strong>?
            This action cannot be undone.
          </p>
        }
        confirmText="Delete"
        confirmColor="error"
      /> */}

      <SuccessSnackbar
        open={openSuccessSnackbar}
        onClose={handleCloseSuccess}
        message={successMessage}
        severity={successMessage.includes('Successfully') ? 'success' : 'error'}
      />
    </FormContainerWrapper>
  );
};

export default PumpUpdateDelete;